import { Component, OnInit } from '@angular/core';
import { LayoutService } from "../layout.service";

@Component({
  selector: 'app-without-header',
  templateUrl: './without-header.component.html',
  styleUrls: ['./without-header.component.css']
})
export class WithoutHeaderComponent implements OnInit {

  constructor(
    private layout_service: LayoutService,
  ) { }

  ngOnInit() { }  

}
